import React, { Component } from 'react'
import { Affix ,Button,message} from "antd"
import { observer, inject } from "mobx-react"

@inject('reportStore') @observer
export default class DataHeader extends Component {

  handleChange= (type,value) => {
    this.props.reportStore.tableData[type]=value
  }
//保存
  saveTableData = () => {
    const { tableData, saveDatas} = this.props.reportStore
    tableData.pointList=tableData.pointList.slice()
      saveDatas(tableData)
      .then(result => {
        message.success("保存成功")
      }, error => {
        message.error(error.message)
      })
  }
  render() {
    const { tableData } = this.props.reportStore
    
    return (
      <Affix
        className="affix-head"
        target={() => document.getElementsByClassName("salt-pagelayout")[0]} offsetTop={0}
      >
        <div className="search-bar">
          <div className="left">
            <div>&nbsp;&nbsp;&nbsp;&nbsp;缺失类型&nbsp;&nbsp;&nbsp;&nbsp;：<input value={tableData.keyword} 
            onChange={(e)=>this.handleChange('keyword', e.target.value)}></input></div>

            <div>&nbsp;&nbsp;&nbsp;&nbsp;缺失名称&nbsp;&nbsp;&nbsp;&nbsp;：<input value={tableData.name} 
            onChange={(e)=>this.handleChange('name', e.target.value)}></input></div>

            <div>缺失STS位点 ：<input value={tableData.stsPoint} 
            onChange={(e)=>this.handleChange('stsPoint', e.target.value)}></input></div>

            <div>Y染色体位置&nbsp;&nbsp;：<input value={tableData.yPosition} 
            onChange={(e)=>this.handleChange('yPosition', e.target.value)}></input></div>

             <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;结果&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;：
              <input value={tableData.result} 
            onChange={(e)=>this.handleChange('result', e.target.value)}></input></div>

             <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;结论&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;：
              <input value={tableData.tips} 
            onChange={(e)=>this.handleChange('tips', e.target.value)}></input></div>

            <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;大小&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;：
            <input value={tableData.size} 
            onChange={(e)=>this.handleChange('size', e.target.value)}></input></div>
          </div>
          <div className='rigBtn'>
                 <Button
                 size = 'large'
                  type="primary"
                  className="export-btn"
                  onClick={this.saveTableData}
                >
                  保存
                </Button>
          </div>
        </div>
      </Affix>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/research/azf/data_manage_detail/containers/DataHeader.js